export enum PermissionsToolsPagesEnum {
  Tools = 1,
  VehicleValidation = 2
}
